import { createReactTableStore } from 'core/memory/pure/react-table-store';

import { TeachersTable } from 'modules/substitute/organisms/teachers-table';

const teachersTableStore = createReactTableStore({}, {});

export const Teachers = () => {
  return <TeachersTable tableStore={teachersTableStore} />;
};
